import React, { Dispatch, SetStateAction } from 'react'

import { X } from '@phosphor-icons/react'
import { Container, Icon, Title } from './styled'

interface HeaderProps {
  title?: string
  onclick?: Dispatch<SetStateAction<boolean>>
}

export const ModalHeader = ({ title, onclick }: HeaderProps) => {
  const toggleFunction = (setValue) => {
    setValue((prev) => !prev)
  }

  return (
    <Container>
      <Title>{title}</Title>
      <Icon onClick={() => toggleFunction(onclick)}>
        <X size={16} color="#BB0000" weight="bold" />
      </Icon>
    </Container>
  )
}
